import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Form, Formik } from 'formik';
import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap';
import TextInput from 'web/components/form-elements/TextInput';
import HOCButton from 'web/components/Button';
import Spinner from 'web/components/Spinner';
import * as Yup from 'yup';
import CheckboxInput from 'web/components/form-elements/CheckboxInput';

import { Container, SectionB } from '../../../account/confirm-password/confirmPasswordStyle';
import * as QueryString from 'query-string';
import { showAppLoader, hideAppLoader } from '../../../../../redux/actions/app';
import axioPath from '../../../../../api/axioPath';
import { Tooltip } from 'reactstrap';
import information from "web/assets/images/informationIcon.png";

function SignUp() {
  let location = useLocation()
  let dispatch = useDispatch()
  let history = useHistory()
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const [modal, setModal] = useState(false);
  const [modalMessage, setModalMessaage] = useState([])
  const [acknowledgeState, setAcknowledgeState] = useState(false);
  const [tooltipPasswordIcon, setTooltipPasswordIcon] = useState(false);
  const INITIAL_VALUES = {
    password: '',
    confirmPassword: '',
    username: ''
  };
  const VALIDATION_SCHEMA = Yup.object().shape({
    password: Yup.string().trim()
      .label('Password')
      .required("Please enter a valid password")
      .min(8, "Please enter a valid password")
      .max(20, "Please enter a valid password")
      .matches(/[a-z]+/, "Please enter a valid password")
      .matches(/[A-Z]+/, "Please enter a valid password")
      .matches(/[@$!%*#?&]+/, "Please enter a valid password")
      .matches(/\d+/, "Please enter a valid password"),
    confirmPassword: Yup.string().trim()
      .required("Password do not match.")
      .oneOf(
        [Yup.ref('password'), null],
        'Passwords must match'
      ),
    username: Yup.string().required("User Name Required")
  });

  const adminSignUp = (props) => {
    const params = QueryString.parse(location.search);
    const token = params.token
    const adminToken = params.admintoken
    dispatch(showAppLoader());
    axioPath.post('/sign-up', {
      name: props.values.username,
      password: props.values.password
    }, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        token: token
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      if (response.data.message === 'Access Granted Succesfully') setModalMessaage(["Access granted. Login to continue."])
      else if (response.data.message === 'User already Exists') setModalMessaage(["Access already granted. Login to continue."])
      else setModalMessaage([response.data?.message || 'Something went wrong, please try again.'])
      setModal(!modal)
    }).catch((ex) => {
      if (ex.response?.status === 401) {
        setModalMessaage(["The token has expired or failed. Please request a new link."])
        setModal(!modal)
      }
      dispatch(hideAppLoader());
    });
  }

  const handleToggle = () => {
    setModal(!modal);
    localStorage.removeItem('adminRolesData')
    localStorage.removeItem('adminName')
    localStorage.removeItem('adminEmail')
    localStorage.removeItem('token')
    if (modalMessage.length > 0 && modalMessage[0] && modalMessage[0].includes('Login to continue')) {
      adminLogout()
    }
  }

  const adminLogout = () => {
    localStorage.removeItem('token')
    history.push('/sign-in')
    window.location.reload(false);
  }
  const passwordIcon = (infoTxt) => {
    return <>
      <img
        id="PasswordIcon"
        alt="image"
        src={information}
        style={{
          paddingLeft: "5px",
          position: "relative",
          top: '9px',
          width: '20px',
          height: '16px'
        }}
      />
      <Tooltip
        placement="right"
        isOpen={tooltipPasswordIcon}
        target="PasswordIcon"
        toggle={() =>
          setTooltipPasswordIcon(!tooltipPasswordIcon)
        }
      >
        {infoTxt}
      </Tooltip>
    </>
  }

  return (
    <>
      <Container>
        {loaderVisible && <Spinner />}
        <SectionB>
          <div className="centered-form-card">
            <Formik
              initialValues={INITIAL_VALUES}
              validationSchema={VALIDATION_SCHEMA}
              onSubmit={(values) => { }}>
              {(props) => {
                const { isValid, dirty } = props;
                return (
                  <>
                    <Form>
                      <div>
                        <h3>Admin Sign Up </h3>
                        <p>Please select a password for your Admin PalletTrader Account.</p>
                        <div>
                          <div style={{ display: 'flex' }}>
                            <p>User Name</p><span className="star" style={{ marginTop: "6px" }}>*</span>
                          </div>
                          <TextInput
                            name='username'
                          />
                        </div>
                        <div>
                          <div style={{ display: 'flex', marginTop: "-15px" }}>
                            <p>Password</p><span className="star" style={{ marginTop: "6px" }}>*</span>
                            {passwordIcon('Password must contain 8 characters, one uppercase, one lowercase, one number and one special case character.')}
                          </div>
                          <TextInput
                            name='password'
                            type='password'
                            placeholder='(At least 8 characters)'
                          />
                        </div>

                        <div>
                          <div style={{ display: 'flex', marginTop: "-15px" }}>
                            <p>Confirm Password</p><span className="star" style={{ marginTop: "6px" }}>*</span>
                          </div>
                          <TextInput
                            name='confirmPassword'
                            type='password'
                            placeholder='(At least 8 characters)'
                          />
                        </div>
                        <div style={{ display: 'flex', marginTop: "-20px" }}>
                          <CheckboxInput
                            name="rememberMe"
                            handleSelect={(e) => {
                              setAcknowledgeState(!acknowledgeState)

                            }}
                            label="I hereby acknowledge and agree to this website's terms and conditions."
                          />

                        </div>
                        <div style={{ display: 'flex', marginTop: "-20px" }}>
                          <HOCButton
                            type='app-green-button'
                            handleClick={() => adminSignUp(props)}
                            disabled={!(isValid && dirty && acknowledgeState)}>
                            Confirm
                          </HOCButton>
                        </div>
                      </div>
                    </Form>
                  </>
                );
              }}

            </Formik>
          </div>
        </SectionB>
      </Container>
      <Modal isOpen={modal} centered={true}>
        <ModalBody style={{ textAlign: 'center', fontSize: '20px' }}>
          {modalMessage.length > 1 && modalMessage[0]}
          {modalMessage.length > 1 && <br />}
          {modalMessage.length > 1 && modalMessage[1]}
          {modalMessage.length === 1 && modalMessage[0]}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleToggle}>OK</Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default SignUp;